<template>
  <div class="col-12 bg-white rounded mt-n3">
    <validation-observer
      ref="returnToPreviousStatusForm"
      v-slot="{}"
      tag="form"
    >
      <div class="row mb-n3">
        <div class="col-12 mt-2">
          <p>
            <i class="h6 fas fa-undo text-orange mr-2 font-weight-bold" />
            <span class="font-weight-bold color-gray-7">
              {{ title }}
            </span>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-12 mt-2">
          <validation-provider
            v-slot="{ errors }"
            name="cancelComment"
            rules="required"
          >
            <label class="data-title mb-0">Comentario:</label>
            <custom-text-area
              v-model="model.comment"
              :count-classes="['float-right']"
              custom-error-msg="El comentario es requerido."
              :error="errors[0]"
              :maxlength="3000"
              show-char-count
            />
          </validation-provider>
        </div>
      </div>
      <div class="row">
        <div class="col-12 mt-3 mr-3">
          <div class="d-flex flex-row-reverse bd-highlight w-100 actions">
            <div class="bd-highlight ml-2">
              <action-button
                i="fas fa-save fa-lg"
                text="Guardar"
                variant="success"
                @click="submitForm()"
              />
            </div>
            <div class="mx-0 bd-highlight">
              <action-button
                id="modal-btn-cancelar"
                i="fas fa-times-circle"
                text="Cancelar"
                variant="outline-danger"
                @click="$emit('cancel')"
              />
            </div>
          </div>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import CustomTextArea from 'CustomTextArea';
import ActionButton from 'ActionButton';
import alert from '@quisit/mipe-utils/mixins/alert.mixin.js';

import {
  returnToNewStatus as _returnToNewStatus,
  returnToPreviousStatus as _returnToPreviousStatus,
} from '@/services/uspqrp/contract.api.js';

export default {
  name: 'ContractReturnToNewStatus',
  components: {
    ValidationProvider,
    CustomTextArea,
    ActionButton,
  },
  mixins: [alert],
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      model: {
        comment: null,
      },
    };
  },
  computed: {
    title() {
      return this.isReturnToPreviousStatus
        ? 'Regresar Estatus Anterior'
        : 'Regresar Estatus Nuevo';
    },
    isReturnToPreviousStatus() {
      return this.data.returnToPreviousStatus;
    },
  },
  methods: {
    async submitForm() {
      const isFormValid = await this.$refs.returnToPreviousStatusForm.validate();
      if (!isFormValid) {
        this.ShowToast('Alerta', 'El comentario es requerido.', 'error');
        return;
      }
      await this.submmitToNewStatus();
    },
    async submmitToNewStatus() {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro(a) que desea regresar al estatus ${
          this.isReturnToPreviousStatus ? this.data.previousStatus : 'Nuevo'
        }?`,
        'Sí',
        'No'
      );

      if (!answer) {
        return;
      }

      const payload = {
        contractId: this.data.contractId,
        ...this.model,
      };

      let response = null;

      if (this.isReturnToPreviousStatus) {
        const { data } = await _returnToPreviousStatus(payload).catch(
          (error) => {
            this.ShowToast('Alerta', `${error.message}.`, 'error');
            return { data: false };
          }
        );
        response = data;
      } else {
        const { data } = await _returnToNewStatus(payload).catch((error) => {
          this.ShowToast('Alerta', `${error.message}.`, 'error');
          return { data: false };
        });
        response = data;
      }

      if (response)
        this.ShowToast(
          `Confirmación`,
          'El estatus ha sido actualizado exitosamente.',
          'success'
        );

      this.$emit('save', response);
    },
  },
};
</script>
